import { Pipe, PipeTransform } from '@angular/core';
import { SessionImageService } from 'app/global/session-image.service';
import { Block } from 'app/interfaces/blocks';

@Pipe({
  name: 'indexDataAttachment',
})
export class IndexDataAttachmentPipe implements PipeTransform {

  constructor(
      private sessionImageService: SessionImageService
    ) {}

  transform(field, indexData): string {
    let result = field?.value;
    const blocks = indexData?.template_fields_datas?.data?.blocks as { [key: string]: Block };
    if (field?.value && blocks) {
      const attachments = Object.values(blocks).filter(
        (b: Block) => b?.type === 'attachment' && b?.meta_data_id === field.metadata_id
      );
      if (attachments.length > 0) {
        const attachment = attachments[0];
        if (attachment?.files?.length > 0) {
          const attachmentUrl = this.sessionImageService.getTemplateImages(
            attachment.files[0].url,
            Number(indexData?.template?.id),
            'document'
          );
          result = `<a href="${attachmentUrl}" target="_blank">${field.value}</a>`;
        }
      }
    }
    return result;
  }
}
